// extracted by mini-css-extract-plugin
export default {"bar":"NavProgressBar_bar__eaAYW","barShimmer":"NavProgressBar_barShimmer__vP6r5"};